import ManageIrrigationTypeTable from './ManageIrrigationTypeTable'

const ManageIrrigationType = {
  Table: ManageIrrigationTypeTable,
}

export default ManageIrrigationType
